<template>
  <div class="map-input">
    <label v-if="label">
      {{ label }}
      <span v-if="required" class="map-label--required">*</span>
    </label>
    <input
      class="map-input__inner"
      :class="classInput"
      v-bind="$attrs"
      :value="value"
      :placeholder="placeholder"
      :required="required"
      :type="type"
      :min="min"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: [Number, String],
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    fullwidth: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium"
    },
    min: {
      type: Number
    }
  },
  data() {
    return {
      inputSize: ["mini", "small", "medium", "large"]
    };
  },
  computed: {
    classInput() {
      const prefix = " map-input--";
      const fw = !this.fullwidth ? "" : prefix + "fullwidth";
      const size =
        this.size == "medium" || this.inputSize.indexOf(this.size) == -1
          ? ""
          : prefix + this.size;
      return (size + fw).trim();
    }
  }
};
</script>
